<template>
    <div class="contact-success-section">
        <div class="container">
            <div class="success-header">
                <h1>{{ successCopy.title }}</h1>
                <p class="subtitle">{{ successCopy.subtitle }}</p>
            </div>
            
            <div class="success-card">
                <!-- Success Icon -->
                <div class="success-icon">
                    <img v-lazy="$ossImg('common/success.png')" :alt="successCopy.cardTitle" class="success-icon-img" />
                </div>
                
                <!-- Success Message -->
                <h2 class="success-title">{{ successCopy.cardTitle }}</h2>
                
                <!-- Description -->
                <p class="success-description">
                    {{ successCopy.description }}
                </p>
                
                <!-- Separator -->
                <div class="success-separator"></div>
                
                <!-- QR Code Section -->
                <div class="qr-code-section">
                    <div class="qr-code-wrapper">
                        <img v-lazy="$ossImg('footer/gzh.png')" :alt="successCopy.qr.alt" class="qr-code-img" />
                    </div>
                    <p class="qr-subtitle" v-html="successCopy.qr.caption"></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ContactSuccess',
    computed: {
        successCopy() {
            const copy = this.$t('contact.success')
            return typeof copy === 'object' ? copy : {}
        }
    }
}
</script>

<style scoped>
.contact-success-section {
    padding: 80px 0;
    padding-top: 129px;
    min-height: calc(100vh - 200px);
    border-radius: 15px;
}

.success-header {
    text-align: center;
    margin-bottom: 40px;
}

.success-header h1 {
    font-size: 2.5rem;
    font-weight: 700;
    color: #000;
    margin-bottom: 16px;
}

.success-header .subtitle {
    font-size: 1rem;
    color: #666;
}

.success-card {
    max-width: 597px;
    margin: 0 auto;
    background: white;
    border-radius: 16px;
    padding: 110px 64px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    text-align: center;
}

.success-icon {
    margin-bottom: 24px;
    display: flex;
    justify-content: center;
}

.success-icon-img {
    width: 48px;
    height: 48px;
}

.success-title {
    font-size: 2rem;
    font-weight: 700;
    color: #000;
    margin-bottom: 16px;
}

.success-description {
    font-size: 0.95rem;
    color: #767676;
    line-height: 1.6;
    margin-bottom: 32px;
}

.success-separator {
    width: 100%;
    height: 1px;
    background: #e0e0e0;
    margin-bottom: 32px;
}

.qr-code-section {
    text-align: center;
}

.qr-code-wrapper {
    display: inline-block;
    background: #F1F1F1;
    padding: 15px;
    /* border-radius: 8px; */
}

.qr-code-img {
    width: 200px;
    height: 200px;
    display: block;
}

.qr-code-wrapper + .qr-instruction {
    margin-top: 16px;
}

.qr-instruction {
    font-size: 0.95rem;
    color: #000;
    margin-bottom: 4px;
    font-weight: 500;
}

.qr-subtitle {
    font-size: 12px;
    color: #767676;
}

/* Responsive */
@media (max-width: 768px) {
    .contact-success-section {
        padding: 40px 0;
    }
    
    .success-card {
        padding: 32px 24px;
        margin: 0 16px;
    }
    
    .success-header h1 {
        font-size: 1.8rem;
    }
    
    .success-title {
        font-size: 1.5rem;
    }
    
    .success-icon-img {
        width: 40px;
        height: 40px;
    }
}
</style>
